import { Edit, Search, Visibility } from "@mui/icons-material";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Switch,
} from "@mui/material";
import React, { useState } from "react";
import getJournalService from "../../../../services/getJournalService";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid } from "@mui/x-data-grid";
import DeleteConfirm from "../../adminComponents/DeleteConfirm";
import { Link } from "react-router-dom";
const label = { inputProps: { "aria-label": "Switch demo" } };

const List = ({
  setIsOpen,
  setFilterVal,
  filterVal,
  fetchData,
  getdata,
  setEditValue,
  setDialogType,
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const paginationModel = { page: 0, pageSize: 5 };

  const handleDelete = async () => {
    try {
      const list = await getJournalService.DeleteJournalList(selectedRow.id);
      fetchData();
      setOpenDelete(false);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleAction = async (value) => {
    const updatedActiveStatus = !value.active;
    const data = {
      active: updatedActiveStatus,
    };
    try {
      // Update the category
      await getJournalService.UpdateJournalList(data, value.id);
      // Re-fetch the updated category list by calling fetchData again
      fetchData();
    } catch (error) {
      console.error("Error updating category or fetching updated list:", error);
    }
  };
  const handleClickEdit = (val) => {
    setEditValue(val);
    setDialogType("edit");
    setIsOpen(true);
  };
  const handleClickOpenDelete = (val) => {
    setOpenDelete(true);
    setSelectedRow(val);
  };
  const handleClose = () => {
    setOpenDelete(false);
  };
  const columns = [
    {
      field: "name",
      headerName: "Publication Name",
      minWidth: 300,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "active",
      headerName: "Active",
      minWidth: 250,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Switch
          {...label}
          checked={params.row.active}
          onChange={() => handleAction(params.row)}
        />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      align: "center",
      headerAlign: "center",
      minWidth: 300,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            className="ms-2"
            size="small"
            onClick={() => handleClickEdit(params.row)}
          >
            <IconButton aria-label="delete" size="small">
              <Edit fontSize="inherit" />
            </IconButton>{" "}
            Edit
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            className="ms-4"
            onClick={() => handleClickOpenDelete(params.row)}
          >
            <IconButton aria-label="delete" color="error" size="small">
              <DeleteIcon fontSize="inherit" />
            </IconButton>{" "}
            Delete
          </Button>
        </>
      ),
    },
  ];

  const handleChangeFiler = (e) => {
    setFilterVal({ ...filterVal, [e.target.name]: e.target.value });
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-end">
        <FormControl
          sx={{ m: 1, width: "25ch" }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            name="search"
            value={filterVal.search}
            // label="Select Category"
            onChange={handleChangeFiler}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
      </div>

      <Paper
        sx={{
          height: "67vh",
          boxShadow: "none",
          width: "100%",
          overflow: "auto",
        }}
      >
        <DataGrid
          rows={getdata}
          columns={columns}
          sx={{ border: 0 }}
          disableColumnMenu
          disableSelectionOnClick
        />
      </Paper>
      <DeleteConfirm
        openDelete={openDelete}
        handleDelete={handleDelete}
        handleClose={handleClose}
      />
    </div>
  );
};

export default List;
